import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=5e4e57ef"
import script from "./TeamMembers.vue?vue&type=script&lang=js"
export * from "./TeamMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TeamMember: require('/vercel/path0/components/shared/TeamMember.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
